<template>
  <div class="d-flex ga-4">
    <TooltipIcon
      v-if="passing === true"
      color="green"
      icon="check_circle"
      text="Correct"
    />

    <TooltipIcon
      v-if="passing === false"
      color="red"
      icon="cancel"
      text="Incorrect"
    />

    <TooltipIcon
      v-if="published === false"
      :color="unpublishedColor"
      icon="hide_source"
      text="Unpublished"
    />

    <TooltipIcon
      v-if="mandatory"
      :color="statusColor('red')"
      aria-label="required"
      icon="emergency"
      text="Required"
    />

    <TooltipIcon
      v-if="conditional"
      :color="statusColor()"
      :text="conditionsTooltipText"
      aria-label="Conditional"
      icon="dynamic_form"
    />

    <TooltipIcon
      v-if="verification"
      :color="statusColor()"
      icon="add_moderator"
      text="Requires verification"
    />

    <TooltipIcon
      v-if="published === true"
      :color="statusColor('green')"
      icon="circle"
      text="Published"
    />
  </div>
</template>

<script setup>
import TooltipIcon from '@/shared/components/TooltipIcon.vue';

const props = defineProps({
  conditional: {
    type: Boolean,
    default: null,
  },
  conditionsFailed: {
    type: Boolean,
    default: null,
  },
  mandatory: {
    type: Boolean,
    default: null,
  },
  passing: {
    type: Boolean,
    default: null,
  },
  published: {
    type: Boolean,
    default: null,
  },
  verification: {
    type: Boolean,
    default: null,
  },
});

const unpublishedColor = 'gray';

function statusColor(color = 'primary') {
  return !props.published || props.conditionsFailed ? unpublishedColor : color;
}

const conditionsTooltipText = computed(() => {
  return props.conditionsFailed ? 'Conditions were not met' : 'Conditional';
});
</script>
